import { Injectable } from '@angular/core';
import jwtDecode from 'jwt-decode';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { Analyse } from '../domain/Analyse/analyse';
import { WaterProcess } from '../domain/EAU/water-process';
import { IBDProcess } from '../domain/IBD/IDB-process';
import { IBGNProcess } from '../domain/IBGN/IBGN-process';
import { Substrat as IBGNSubstrat } from '../domain/IBGN/substrat';
import { IBMRProcess } from '../domain/IBMR/IBMR-process';
import { IMLProcess } from '../domain/IML/IML-process';
import { LacProcess } from '../domain/Lac - EAU/lac-process';
import { MGCEProcess } from '../domain/MGCE/MGCE-Process';
import { Process } from '../domain/MPCE/process';
import { Substrat as MPCESubstrat } from '../domain/MPCE/substrat';
import { Intervention } from '../domain/planning/intervention';
import { User } from '../domain/planning/user';
import { Permissions } from '../domain/user-profile/permissions';
import { NotificationManager } from './notification-manager';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class CoreData {

    public IsOffline: boolean;
    private LASTINTERVENTIONLOADEDINDOCUMENT = 'HEBI_LASTINTERVENTIONLOADEDINDOCUMENT' + environment.name;
    private TOKEN = `${environment.appCode}_TOKEN_` + environment.name;
    private REFRESH_TOKEN = `${environment.appCode}_REFRESH_TOKEN_` + environment.name;
    private OFFLINEKEY = 'HEBI_OFFLINE';
    private INTERVENTION_LIST = 'HEBI_INT_LIST';
    private ANALYSE_LIST = 'HEBI_ANAL_LIST';
    private SCOPE = `${environment.appCode}_SCOPE`;
    private ROLE_AND_PERMISSIONS = `${environment.appCode}_ROLE_AND_PERMISSIONS`;
    private PAGE_NAME = `${environment.appCode}_PAGE_NAME_` + environment.name;
    // private OTHER_PICTURE_DESCRIPTION = 'HEBI_OTHER_PICTURE_DESCRIPTION';
    private IS_INVERVENTION_SELECTED = `${environment.appCode}_IS_INVERVENTION_SELECTED_` + environment.name;

    private CURRENT_INTERVENTION = `${environment.appCode}_CURRENT_INTERVENTION_` + environment.name;

    get IsMobile() {
        return window.navigator.userAgent.includes('Mobi');
        // window.innerWidth < 960;
    }

    get CurrentPageName() {
        return localStorage.getItem(this.PAGE_NAME)!;
    }
    set CurrentPageName(name: string) {
        localStorage.setItem(this.PAGE_NAME, name);
    }

    get CurrentIntervention() {
        return JSON.parse(localStorage.getItem(this.CURRENT_INTERVENTION)!);
    }
    set CurrentIntervention(int: Intervention) {
        localStorage.setItem(this.CURRENT_INTERVENTION, JSON.stringify(int));
    }

    get IsInverventionSelected() {
        return JSON.parse(localStorage.getItem(this.IS_INVERVENTION_SELECTED)!);
    }
    set IsInverventionSelected(inIntervention: boolean) {
        localStorage.setItem(this.IS_INVERVENTION_SELECTED, `${inIntervention}`);
    }

    public get IsLoggedIn() {
        return this.Token !== undefined && this.Token !== null;
    }

    get User() {
        return this.Token ? this.getUserFromJWTToken() : null;
    }

    getUserFromJWTToken() {
        const u = new User();
        const decodedToken = jwtDecode(this.Token) as any;
        if (decodedToken) {
            u.Email = decodedToken.email;
            u.Fullname = decodedToken.display_name;
        }
        return u;
    }
    // get UserInformation() {
    //     if (localStorage.getItem(this.USERKEY)) {
    //         return JSON.parse(atob(localStorage.getItem(this.USERKEY)));
    //     }
    // }

    // set UserInformation(ui: PermissionDto) {

    //     if (ui) {
    //         localStorage.setItem(this.USERKEY, btoa(JSON.stringify(ui)));
    //     } else {
    //         localStorage.removeItem(this.USERKEY);
    //     }
    // }

    get Token() {
        return localStorage.getItem(this.TOKEN);
    }

    set Token(token) {
        localStorage.setItem(this.TOKEN, token);
    }

    get RefreshToken() {
        return localStorage.getItem(this.REFRESH_TOKEN);
    }

    set RefreshToken(token) {
        localStorage.setItem(this.REFRESH_TOKEN, token);
    }

    clearToken() {
        localStorage.removeItem(this.TOKEN);
    }

    get LastInterventionLoadedInDocument() {
        if (localStorage.getItem(this.LASTINTERVENTIONLOADEDINDOCUMENT)) {
            return JSON.parse(atob(localStorage.getItem(this.LASTINTERVENTIONLOADEDINDOCUMENT)));
        }
    }

    set LastInterventionLoadedInDocument(sampleCode: string) {
        if (sampleCode) {
            localStorage.setItem(this.LASTINTERVENTIONLOADEDINDOCUMENT, btoa(JSON.stringify(sampleCode)));
        } else {
            localStorage.removeItem(this.LASTINTERVENTIONLOADEDINDOCUMENT);
        }
    }

    get SelectedScopeCode() {
        return localStorage.getItem(this.SCOPE);
    }

    set SelectedScopeCode(scope: string) {
        localStorage.setItem(this.SCOPE, scope);
    }

    get RoleAndPermissions() {
        if (localStorage.getItem(this.ROLE_AND_PERMISSIONS)) {
            return JSON.parse(atob(localStorage.getItem(this.ROLE_AND_PERMISSIONS)));
        }
    }

    set RoleAndPermissions(ui: Permissions[]) {
        if (ui) {
            localStorage.setItem(this.ROLE_AND_PERMISSIONS, btoa(JSON.stringify(ui)));
        } else {
            localStorage.removeItem(this.ROLE_AND_PERMISSIONS);
        }
    }

    constructor(private snackBar: MatSnackBar) {

    }

    writeToLocalStorage(key: string, data: any) {
        try {
            localStorage.setItem(key, data);
        } catch {
            NotificationManager.handleError('LocalStorage Quota Exceeded', this.snackBar);
            return false;
        }
        return true;
    }

    getTypeOfDevice() {
        const isMobile = window.navigator.userAgent.includes('Mobi');
        this.IsOffline = isMobile;
    }

    getOfflineIntervention(code: string): Intervention {
        if (localStorage.getItem(code)) {
            return JSON.parse(localStorage.getItem(code)) as Intervention;
        }
        return null;
    }

    setOfflineIntervention(int: Intervention) {
        if (int) {
            return this.writeToLocalStorage(int.Code, JSON.stringify(int));
            // localStorage.setItem(int.Code, JSON.stringify(int));
        }
    }

    // setOfflineInterventionPictureList(code: string, type: EDocumentType, uidisabled?: boolean) {
    //     const d = new Document();
    //     d.DocumentType = type;
    //     d.UIDisabled = uidisabled ?? false;
    //     const list = this.getOfflineInterventionPictureList(code);
    //     list.push(d);
    //     // localStorage.setItem(`${code}_PICTURES`, JSON.stringify(list));
    //     return this.writeToLocalStorage(`${code}_PICTURES`, JSON.stringify(list));
    // }

    // getOfflineInterventionPictureList(code: string): Document[] {
    //     const list = JSON.parse(localStorage.getItem(`${code}_PICTURES`));
    //     return list ? list : [];
    // }

    // removeFromOfflinePictureList(code: string, type: EDocumentType) {
    //     const list: Document[] = JSON.parse(localStorage.getItem(`${code}_PICTURES`));
    //     _.remove(list, x => x.DocumentType === type);

    //     // localStorage.setItem(`${code}_PICTURES`, JSON.stringify(list));
    //     return this.writeToLocalStorage(`${code}_PICTURES`, JSON.stringify(list));
    // }

    getOtherPictureDescription(interventionCode: string) {
        return localStorage.getItem(`${interventionCode}_OTHER_PICTURE`);
    }

    setOtherPictureDescription(interventionCode: string, desc: string) {
        this.writeToLocalStorage(`${interventionCode}_OTHER_PICTURE`, desc);
    }

    getLastSondePhRef() {
        return localStorage.getItem(`_LAST_SONDE_PH`);
    }

    setLastSondePhRef(desc: string) {
        this.writeToLocalStorage(`_LAST_SONDE_PH`, desc);
    }

    getLastSondeOxyRef() {
        return localStorage.getItem(`_LAST_SONDE_OXY`);
    }

    setLastSondeOxyRef(desc: string) {
        this.writeToLocalStorage(`_LAST_SONDE_OXY`, desc);
    }

    getLastSondeCondRef() {
        return localStorage.getItem(`_LAST_SONDE_COND`);
    }

    setLastSondeCondRef(desc: string) {
        this.writeToLocalStorage(`_LAST_SONDE_COND`, desc);
    }

    getOfflineInterventionDescription(code: string) {
        if (localStorage.getItem(`${code}_DESC`)) {
            return JSON.parse(localStorage.getItem(`${code}_DESC`)) as Intervention;
        }
        return null;
    }

    setOfflineInterventionDescription(code: string, int: Intervention) {
        if (int) {
            // localStorage.setItem(`${code}_DESC`, JSON.stringify(int));
            return this.writeToLocalStorage(`${code}_DESC`, JSON.stringify(int));
        }
    }

    getOfflineAnalyse(code: string) {
        if (localStorage.getItem(`${code}_ANALYSE`)) {
            return JSON.parse(localStorage.getItem(`${code}_ANALYSE`)) as Analyse;
        }
        return null;
    }

    setOfflineAnalyse(code: string, analyse: Analyse) {
        if (analyse) {
            // localStorage.setItem(`${code}_DESC`, JSON.stringify(int));
            return this.writeToLocalStorage(`${code}_ANALYSE`, JSON.stringify(analyse));
        }
    }

    getOfflineProcess(code: string): Process | IBGNProcess | IBDProcess | WaterProcess | LacProcess | MGCEProcess | IBMRProcess | IMLProcess {
        if (localStorage.getItem(code)) {
            return JSON.parse(localStorage.getItem(code));
        }
        return null;
    }

    setOfflineProcess(int: Process | IBGNProcess | IBDProcess | WaterProcess | LacProcess | MGCEProcess | IBMRProcess | IMLProcess) {
        if (int) {
            // localStorage.setItem(int.Code, JSON.stringify(int));
            return this.writeToLocalStorage(int.Code, JSON.stringify(int));
        }
    }

    getOfflineProcessSubstratList(code: string): MPCESubstrat[] | IBGNSubstrat[] {
        if (localStorage.getItem(`${code}_SUB`)) {
            return JSON.parse(localStorage.getItem(`${code}_SUB`));
        }
        return null;
    }

    setOfflineProcessSubstratList(code: string, list: MPCESubstrat[] | IBGNSubstrat[]) {
        if (list) {
            // localStorage.setItem(`${code}_SUB`, JSON.stringify(list));
            return this.writeToLocalStorage(`${code}_SUB`, JSON.stringify(list));
        }
    }

    getLocalAnalyseList(): string[] {
        const list = JSON.parse(localStorage.getItem(this.ANALYSE_LIST));
        return list ? list : [];
    }

    pushToAnalyseLocalList(interventionCode: string) {
        const list = this.getLocalAnalyseList();
        list.push(interventionCode);
        // localStorage.setItem(this.INTERVENTION_LIST, JSON.stringify(list));
        return this.writeToLocalStorage(this.ANALYSE_LIST, JSON.stringify(list));
    }

    removeFromAnalyseLocalList(interventionCode: string) {
        const list = this.getLocalAnalyseList();
        _.remove(list, s => s === interventionCode);
        // localStorage.setItem(this.INTERVENTION_LIST, JSON.stringify(list));
        return this.writeToLocalStorage(this.ANALYSE_LIST, JSON.stringify(list));
    }

    getLocalInterventionList(): string[] {
        const list = JSON.parse(localStorage.getItem(this.INTERVENTION_LIST));
        return list ? list : [];
    }

    pushToLocalList(interventionCode: string) {
        const list = this.getLocalInterventionList();
        list.push(interventionCode);
        // localStorage.setItem(this.INTERVENTION_LIST, JSON.stringify(list));
        return this.writeToLocalStorage(this.INTERVENTION_LIST, JSON.stringify(list));
    }

    removeFromLocalList(interventionCode: string) {
        const list = this.getLocalInterventionList();
        _.remove(list, s => s === interventionCode);
        // localStorage.setItem(this.INTERVENTION_LIST, JSON.stringify(list));
        return this.writeToLocalStorage(this.INTERVENTION_LIST, JSON.stringify(list));
    }

    clearLocalIntervention(interventionCode: string, processCode: string) {
        localStorage.removeItem(interventionCode);
        localStorage.removeItem(`${interventionCode}_DESC`);
        localStorage.removeItem(processCode);
        localStorage.removeItem(`${processCode}_SUB`);
        localStorage.removeItem(`${interventionCode}_ANALYSE`)
        // if (this.getOfflineInterventionPictureList(interventionCode)) {
        //     this.getOfflineInterventionPictureList(interventionCode).forEach(type => {
        //         localStorage.removeItem(`${interventionCode}_${type}`);
        //     });
        // }

        localStorage.removeItem(`${interventionCode}_PICTURES`);
    }

    getTotalPercentageAmountOfLocalStorage() {
        let total = 0;

        for (let i = 0; localStorage.key(i) !== null; i++) {
            total += localStorage.getItem(localStorage.key(i)).length;
        }

        return Math.round(total / (1024 * 1024 * 5) * 100); // 5M sur Chrome and Firefox
    }
}
